/**
 * Enumeration which represents type of absence declaration.
 * Regular - Up to 90 days
 * Premium - More than 90 days
 */
export enum AbsenceDeclarationTypeEnumeration {
	REGULAR = 'regularAbsence',
	PREMIUM = 'premiumAbsence',
}
